import {
  dispatchObjErrors,
  buildBrcPhoneConfig,
} from "@features/schema-management/interfaces/sypiBrcInterface";
import { dispatchWalletsErrors } from "@features/schema-management/interfaces/syfCardAccessInterface";

//FEATURES
export const SYF_CARD_ACCESS = "syf_card_access";
export const SYPI_BRC = "sypi_brc";
export const REWARDS_MFE_ATHOS = "rewards_mfe_athos";
export const STATEMENTS_MFE_ATHOS = "statements_mfe_athos";
export const ATHOS_DEFAULT_PATTERN_PROPERTY_KEY = "clientName";

//VALIDATION
export const AJV_2020_VALIDATION =
  "https://json-schema.org/draft/2020-12/schema";

export const SCHEDULE_DRAFT_STATUS = {
  SCHEDULED: "scheduled",
  DRAFT: "draft",
  COMPLETED: "completed",
};

export const SCHEDULE_DRAFT_ACTIONS = {
  DELETE_SCHEDULED: "deleteScheduled",
  DELETE_DRAFT: "deleteDraft",
  DELETE_COMPLETED: "deleteCompleted",
  SCHEDULED_SUMMARY: "scheduledSummary",
  DRAFT_SUMMARY: "draftSummary",
  COMPLETED_SUMMARY: "completedSummary",
  CHANGE_RELEASE_VERSION: "changeReleaseVersion",
  UPDATE_SCHEDULED: "updateScheduled",
  SUBMIT_SUMMARY: "submitSummary",
  SUBMIT_FORM: "submitForm",
  START_SCHEDULE_DRAFT_PROCESS: "startScheduleDraftProcess",
  UPDATE_DRAFT: "updateDraft",
  CHANGE_RELEASE_VERSION: "changeReleaseVersion",
};

export const SCHEDULE_DRAFT_SAVE_STATE = {
  CREATE: "create",
  UPDATE_SCHEMA: "updateSchema",
  EDIT: "edit",
};
export const DISPATCH_ERRORS = {
  sypi_brc: dispatchObjErrors,
  statements_mfe_athos: dispatchObjErrors,
  rewards_mfe_athos: dispatchObjErrors,
  syf_card_access: dispatchWalletsErrors,
};

export const ACTION_TABS = {
  sypi_brc: { hideDefaults: false, expandAll: true },
  statements_mfe_athos: { hideAll: false, expandAll: true },
  rewards_mfe_athos: { hideAll: false, expandAll: true },
};

export const ACTION_TAB = {
  sypi_brc: "hideDefaults",
  statements_mfe_athos: "hideAll",
  rewards_mfe_athos: "hideAll",
};

export const ACTION_TABS_PAGES = {
  sypi_brc: "content",
  statements_mfe_athos: "statementsMfeAthos",
  rewards_mfe_athos: "rewardsMfeAthos",
};
export const SCHEMA_MANAGEMENT_LABELS = {
  syf_card_access: "Syf Card Access",
  statements_mfe_athos: "Statements MFE",
  rewards_mfe_athos: "Rewards MFE",
  sypi_brc: "SyPI Commercial",
  wallets: "Wallets",
};
export const SCHEMA_MANAGEMENT_PATHNAMES = {
  wallets: "syf-card-access",
};

export const PHONE_SCREEN_CONFIG = {
  sypi_brc: buildBrcPhoneConfig,
};

export const SYPI_BRC_SECTIONS = {
  aboutYourBusinessSection: "aboutYourBusiness.businessInformation",
  contactInfoSection: "aboutYourBusiness.contactInformation",
  businessLocationSection: "aboutYourBusiness.businessLocation",
  taxInformationSection: "aboutYourBusiness.taxInformation",
  authRepresentativeSection: "applicantInformation.authorizedRepresentative",
  personalGuarantorSection: "applicantInformation.personalGuarantor",
  beneficialOwnerSection: "applicantInformation.beneficialOwner",
  authBuyersSection: "applicantInformation.addAuthorizedBuyers",
  terms: "termsAndConditions",
  result: "applicationResults",
};

export const SCHEMA_MANAGEMENT_ROUTES = {
  SYPI_BRC_SCHEDULE: "/schema-management-sypi-brc-config-schedule",
  SYPI_BRC_CONTENT: `/schema-management-sypi-brc-content`,
  SYPI_BRC_STYLES: "/schema-management-sypi-brc-styles",
  SYPI_BRC_FEATURES: `/schema-management-sypi-brc-features`,
  SYPI_BRC_IMPORT: `/schema-management-sypi-brc-import`,
  SYPI_BRC_BUSINESS_RULES: `/schema-management-sypi-brc-business-rules`,
  SYF_CARD_ACCESS: `/schema-management-syf-card-access`,
  SYF_CARD_ACCESS_SCHEDULE: `/schema-management-syf-card-access-config-schedule`,
  ATHOS_REWARDS: "/schema-management-rewards-mfe-athos",
  ATHOS_REWARDS_SCHEDULE: "/schema-management-rewards-mfe-athos-config-schedule",
  ATHOS_REWARDS_IMPORT: "/schema-management-rewards-mfe-athos-import",
  ATHOS_STATEMENTS: "/schema-management-statements-mfe-athos",
  ATHOS_STATEMENTS_SCHEDULE: "/schema-management-statements-mfe-athos-config-schedule",
  ATHOS_STATEMENTS_IMPORT: "/schema-management-statements-mfe-athos-import",
  SYF_CARD_ACCESS_IMPORT: `/schema-management-syf-card-access-import`,
};

